import {SOPutAlertSubscription} from '../../core/alert-subscription/so-put-alert-subscription';
import {AlertSubscriptionCore} from './alert-subscription.core';
import {SOGetAlertSubscription} from '../../core/alert-subscription/so-get-alert-subscription';
import {FormField, SelectionOption} from 'lionheartland';
import {putAlertSubscriptionFormFieldOptions} from './put-alert-subscription-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {TopicCore} from '../topic/topic.core';
import {SOGetTopic} from '../../core/topic/so-get-topic';
import {DatafeedCore} from '../datafeed/datafeed.core';
import {SOGetDatafeed} from '../../core/datafeed/so-get-datafeed';

export class RAPutAlertSubscription extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putAlertSubscriptionFormFieldOptions);

  RequestClass = SOPutAlertSubscription

  constructor(
    public entityCore: AlertSubscriptionCore
  ) {
    super();
    if (putAlertSubscriptionFormFieldOptions.topic) {
      putAlertSubscriptionFormFieldOptions.topic.makeCore = true;
    }
    if (putAlertSubscriptionFormFieldOptions.datafeed) {
      putAlertSubscriptionFormFieldOptions.datafeed.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier(
        'topic',
        SOGetTopic,
      ),
      this.getFormValueFromIdentifier(
        'datafeed',
        SOGetDatafeed,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}